export enum NewsAnnouncementCategories {
  AgencySpecific = 'AgencySpecific',
  GenericInformation = 'GenericInformation',
  ProblemsAndFixes = 'ProblemsAndFixes',
  PublicUser = 'PublicUser',
  RecentSystemUpdates = 'RecentSystemUpdates'
}
